import firebase from 'firebase/app'
import firestore from 'firebase/firestore'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyBkJ4mB1ltEwKWvB4wqznKoo9aAO6jhQ-U",
    authDomain: "thanphod-graphicart.firebaseapp.com",
    databaseURL: "https://thanphod-graphicart.firebaseio.com",
    projectId: "thanphod-graphicart",
    storageBucket: "thanphod-graphicart.appspot.com",
    messagingSenderId: "763160672973"
  };
  const firebaseApp = firebase.initializeApp(config);
  firebaseApp.firestore().settings({timestampsInSnapshots:true});
// export firestore database
export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js